// extracted by mini-css-extract-plugin
export var skipLink = "gr_xV";